<div class="dialog-actions">
    <h2 mat-dialog-title class="dialog-title">
        <mat-icon class="edit-icon">edit</mat-icon> Edit Comment
    </h2>

    <mat-divider></mat-divider>

    <mat-dialog-content class="dialog-content">
        <form [formGroup]="commentForm">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Your Comment</mat-label>
                <textarea matInput formControlName="comments" rows="4" cols="10"></textarea>
            </mat-form-field>
            <label (click)="fileInput.click()">
                <mat-icon  class="attachment-icon-cmt">attachment</mat-icon>
              </label>
            <input   #fileInput type="file" (change)="onFileSelected($event)" accept="image/*,.pdf,.doc,.docx" multiple hidden />
            <div *ngIf="comments_attachments.length > 0" class="image-preview-container">
                <div *ngFor="let file of comments_attachments; let i = index" (click)="viewcommentDocuments(comments_attachments,i)" class="preview-wrapper">
                  
                  <img *ngIf="file.type.startsWith('image/')" [src]="file.url" class="preview-image" />
              
                  <div *ngIf="file.type === 'application/pdf'"  >
                    <img src="assets/images/file_icons/pdf.svg" class="preview-image" />
                  </div>
              
                  <div *ngIf="file.type === 'application/msword' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'" 
                  >
                    <img src="assets/images/file_icons/doc.svg" class="preview-image" />
                </div>
                  <mat-icon class="remove-icon" (click)="removeFile(i)">close</mat-icon>
                </div>
              </div>


        </form>
    </mat-dialog-content>

    <!-- <mat-divider></mat-divider> -->

    <div class="modal-footer">
        <button type="button" mat-button (click)="cancel()" class="">
            <span> Cancel </span>
        </button>
        <button type="submit" type="button" mat-button (click)="submitData()" class="global-btn delete-btn"
            style="background-image: linear-gradient(to right, #e40000, #fca300) !important;">
            <span>Update</span>
        </button>
    </div>
</div>